import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:5000";

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function saveSession(token, role, profile) {
  localStorage.setItem("token", token);
  localStorage.setItem("role", role);
  localStorage.setItem("profile", JSON.stringify(profile));
}

export function clearSession() {
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("profile");
}

export function getRole() {
  return localStorage.getItem("role");
}

export function getProfile() {
  const raw = localStorage.getItem("profile");
  return raw ? JSON.parse(raw) : null;
}

export default api;
